<template>
	<div>
		<p>downloading app...</p>
		<a id="downloadLink">download manually</a>
		<button v-on:click="downloadApp()">download manually</button>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
	name: 'home',
	data() {
		return {
			perms:[],
			from: null,
		}
	},
	async created () {
		this.perms = api.getPerms();
		if(this.perms.includes('96')){
			this.downloadApp();
		}else{
			this.back()
		}
	},
	methods:{
		downloadApp(){
			api.getMobileDownload(
				{
					type:"search",
					data:{
						pageid:this.id
					}
				},
				"candidate"
			).then((res) => {
				if(res.data!=null){
					var fileURL = URL.createObjectURL(new Blob([res.data]));
					const link = document.createElement('a');

					link.href = fileURL;
					link.setAttribute('download', 'app-debug.apk');
					link.click();

					URL.revokeObjectURL(link.href);
				}

				//this.back()
			});
		},
		back(){
			if(this.from.path=="/downloadcandidateapp" || this.from.path==null){
				router.replace("/");
			}else{
				router.replace(this.from.path);
			}
		}
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.from = from;
		});
	}
}
</script>

<style scoped>
.frame{
	/*  583.5/2=291.75  */
	margin-left:calc(50% - 291.75pt);
    width:583.5pt;
    height:calc(100vh - 60px);
    border:none;
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadCandidateApp.vue